(function() {
    'use strict';

    function Model() {
        this.cardsData = window.apps.json;
    }

    Model.prototype.getCards = function() {
        return this.cardsData;
    };

    Model.prototype.getCardsByCategory = function(categoryLink) {
        var cards = [];
        var cardLink = '';
        var index;

        for (index = 0; index < this.cardsData.length; index++) {
            cardLink = this.cardsData[index].card_link;

            if (cardLink.indexOf(categoryLink) + 1 || cardLink === 'all') {
                cards.push(this.cardsData[index]);
            }
        }

        return cards;
    };

    window.apps = window.apps || {};
    window.apps.Model = Model;
})();



// WEBPACK FOOTER //
// ./assets/js/projects/apps/widgets/cards-model.js